import { render } from "./CardSwiper.vue?vue&type=template&id=24f648f0"
import script from "./CardSwiper.vue?vue&type=script&lang=js"
export * from "./CardSwiper.vue?vue&type=script&lang=js"

import "./CardSwiper.vue?vue&type=style&index=0&id=24f648f0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__